<template>
  <div>
    <div class="header">
      <div class="header-inner">
        <van-icon name="arrow-left" class="left-icon" @click="$router.go(-1)" />
        <van-search v-model="inputValue" shape="round" placeholder="请输入游戏名称" @search="getSearch" @clear="clearSearch" />
        <p @click="getSearch">搜索</p>
      </div>
    </div>
    <div class="hotSearch">
      <div class="itemBox">
        <p class="hot">
          <img src="../../assets/bx/dj/hot.png" alt="" />
          热门搜索
        </p>
        <p v-for="(item, i) in hotList" :key="item.id" @click="changeActive(i)">
          {{ item.app_name }}
        </p>
      </div>
    </div>
    <van-empty description="未搜索到该游戏" v-if="show" />
    <div v-else>
      <van-index-bar :index-list="Object.keys(gameList)">
        <div v-for="(item, index) in gameList" :key="index">
          <van-index-anchor :index="index" :key="index" />
          <div>
            <van-swipe-cell v-for="(game, index) in item" :key="index">
              <van-cell class="cell" @click="goDetail(game.id)">
                <template #title>
                  <van-image class="games-image" width="4rem" height="4rem" :src="game.icon" />
                  <div class="games-name">{{ game.app_name }}</div>
                </template>
              </van-cell>
            </van-swipe-cell>
          </div>
        </div>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
  import convertToPinyin from "../../utils/converToPinyin";
  export default {
    data() {
      return {
        inputValue: "",
        activeIndex: null,
        hotList: [],
        gameList: {}, //存储排序后的游戏名称
        gameId: "",
        list: [], // 存储请求的数据
        show: false,
        searchData: [],
      };
    },
    created() {},
    mounted() {
      this.getHotList();
      this.getGameList();
    },
    methods: {
      goDetail(id) {
        this.$router.push({
          path: "/detail",
          query: {
            app_id: id,
          },
        });
      },
      // 获取热门搜索
      getHotList() {
        this.$Ajax("game/hot-serach", {}, "get").then((rs) => {
          if (rs.code === 200) {
            this.hotList = rs.data.slice(0, 5);
          }
        });
      },
      // 获取列表
      getGameList() {
        this.$Ajax("game/app-list", {}, "post").then((rs) => {
          if (rs.code == 200) {
            this.list = rs.data;
          }
          const Letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          // 存放所有游戏
          let obj = {};
          //将名字转换成拼音
          for (var i = 0; i < this.list.length; i++) {
            this.list[i].pinyin = convertToPinyin.pinyin.getFullChars(
              this.list[i].app_name
            );
            // 获取首字母转成大写
            var initial = this.list[i].pinyin.slice(0, 1).toUpperCase();
            this.list[i].initial = Letters.indexOf(initial) > -1 ? initial : "#";

            if (!obj[initial]) {
              obj[initial] = [];
            }
            obj[initial].push(this.list[i]);
          }
          //使用GameList
          this.gameList = obj;
        });
      },
      // 热门搜索改变
      changeActive(i) {
        this.activeIndex = i;
        this.inputValue = this.hotList[i].app_name;
        this.getSearch()
      },
      clearSearch() {
        this.inputValue = ''
        this.getSearch()
      },
      // 选中gameList的内容
      selectGame(name) {
        this.inputValue = name;

      },
      // 搜索
      getSearch() {
        this.show = false
        const Letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        // 存放所有游戏
        let obj = {};
        //将名字转换成拼音
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].app_name.indexOf(this.inputValue) != -1) {
            this.list[i].pinyin = convertToPinyin.pinyin.getFullChars(
              this.list[i].app_name
            );
            // 获取首字母转成大写
            var initial = this.list[i].pinyin.slice(0, 1).toUpperCase();
            this.list[i].initial = Letters.indexOf(initial) > -1 ? initial : "#";

            if (!obj[initial]) {
              obj[initial] = [];
            }
            obj[initial].push(this.list[i]);
          }
        }
        this.gameList = obj
        if (JSON.stringify(this.gameList) == "{}") {
          this.show = true
        }
      },
    },
  };
</script>

<style scoped lang="less">
  .header {
    height: 7rem;
    position: fixed;
    top: 0;
    left: 50%;
    width: 100%;
    max-width: 525px;
    z-index: 100;
    transform: translateX(-50%);

    &::after {
      content: "";
      position: absolute;
      bottom: -.5rem;
      left: 0;
      width: 100%;
      height: 1.5rem;
      background-color: #fff;
      border-top-left-radius: 1rem;
      border-top-right-radius: 1rem;
    }

    .header-inner {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      width: 100%;
      background: linear-gradient(33deg, #ff625a 0%, #df5f56 80%);
      height: 100%;
      padding-bottom: 1.2rem;
      position: relative;

      .left-icon {
        color: #ffff;
        font-size: 2rem;
        cursor: pointer;
      }

      /deep/.van-search {
        display: flex;
        flex: 0.8;
        height: 3rem;
        padding: 0;
        background-color: unset;

        .van-search__content {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;

          .van-field__left-icon {
            .van-icon {
              font-size: 1.6rem;
            }
          }

          .van-cell__value {
            font-size: 1.4rem;
          }

          .van-icon-clear {
            z-index: 100;
          }
        }
      }

      p {
        color: #ffff;
        font-size: 1.8rem;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }

  .hotSearch {
    margin: 0 1rem 1rem;
    padding-top: 7rem;

    .itemBox {
      display: flex;
      flex-wrap: wrap;

      p {
        margin: 0.5rem;
        padding: 0 1rem;
        font-size: 1.2rem;
        background: #ffff;
        border-radius: 0.85rem;
        color: #878688;
      }

      .hot {
        color: #fe1a0f;
        font-weight: 700;

        img {
          width: 1rem;
          height: 1rem;
        }
      }

      .isActive {
        color: black;
        font-weight: 700;
      }
    }
  }
  .van-index-bar {
    background-color: #fff;
    margin: 0 1.2rem 1rem;
    border-radius: 0.5rem;
    overflow: hidden;
    /deep/.van-index-bar__sidebar {
      right: 1.5rem;
    }
  }
  .van-cell__title {
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .games-name {
    margin-left: 1rem;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 4rem;
  }

  .cell {
    
    overflow: hidden;
  }

  /deep/.van-index-bar__sidebar {
    right: .5rem;
  }
  
</style>